export function getHtmlFromAjaxResponse(data, xhr) {
  if (xhr && typeof xhr.responseText === 'string') {
    return xhr.responseText;
  }

  if (typeof data === 'string') {
    return data;
  }

  if (data && data.body && typeof data.body.innerHTML === 'string') {
    return data.body.innerHTML;
  }

  return '';
}
